import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ASSUMPTIONS_TABS, INFLATION_TAB } from 'Consts/facet-plan';
import { Tab, Tabs } from '@material-ui/core';
import AssumptionSection from './AssumptionSection';

const styles = () => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexDirection: 'column',
  },
});

export const StyledTabs = withStyles(theme => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.facet.accentBlue,
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    opacity: 0.7,
    '&:focus': {
      opacity: 1,
    },
    '&:hover': {
      opacity: 1,
    },
    '&.Mui-selected': {
      opacity: 1,
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightFacetBold,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const AssumptionAdminLayout = ({
  className,
  classes,
}) => {
  const [tabValue, setTabValue] = React.useState(INFLATION_TAB);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const getSelectedTab = () => {
    const [tab] = ASSUMPTIONS_TABS.filter(t => t.key === tabValue);
    return tab;
  };

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <StyledTabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabChange}
        aria-label="Assumption tabs"
        variant="scrollable"
        scrollButtons="on"
      >
        {ASSUMPTIONS_TABS.map(tab => {
          return !tab.isHidden && (
          <StyledTab
            key={tab.key}
            value={tab.value}
            label={tab.label}
            test={tab.test}
          />
          );
        })}
      </StyledTabs>
      <AssumptionSection
        fields={getSelectedTab().fields}
      />
      <MetaField attr={'changedByPerson'} />
    </div>
  );
};

AssumptionAdminLayout.defaultProps = {
  className: '',
};

AssumptionAdminLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AssumptionAdminLayout);
